'use strict';

/**
 *
 * @name: nnTaxonomiesNavigation
 *
 */
import _throttle from 'lodash.throttle'

import DirectiveTemplate from './nn-taxonomies-navigation.directive.html';
import './nn-taxonomies-navigation.directive.scss';

function NnTaxonomiesNavigationDirective() {

  'ngInject';

  return {
    restrict: 'E',
    replace: true,
    scope: {
      settings: '=nnTaxonomiesNavigation'
    },
    template: DirectiveTemplate,
    controller: nnTaxonomiesNavigationController,
    controllerAs: 'tn'
  };
}

function nnTaxonomiesNavigationController(
  $rootScope,
  $scope,
  $document,
  $element,
  $timeout,
  $translate,
  navigationAnalytics,
  apiModulesService,
  apiSeasonsService,
  transObject,
  $location
) {

  'ngInject';

  /**
   *
   * @CONFIG
   *
   */

  /*jshint validthis: true */
  var tn = this;

  tn.settings = $scope.settings;
  tn.tabs = [];
  tn.isExpanded = false;
  tn.activeTab = '';
  tn.tabsLoading = true;
  $scope.$location = $location

  /**
   *
   * @PUBLIC_METHODS
   *
   */
  tn.talentAwards = function () {
    window._hmt.push(['_trackEvent', `首页-导航-NOWNESS中国天才计划按钮`, 'click', `首页-导航-NOWNESS中国天才计划按钮`]);
  }
  tn.setActive = function (index) {

    var counter = 0;
    tn.tabs.forEach(function (_item, _index) {
      // console.log(_item)
      if (index === _index) {
        console.log(_item,23)
        window._hmt.push(['_trackEvent', `首页-导航-${_item.titleCN}按钮`, 'click', `首页-导航-${_item.titleCN}按钮`]);
        tn.tabs[_index].isActive = tn.tabs[_index].isActive ? false : true;
        tn.activeTab = tn.tabs[_index].title.toLowerCase();
      } else {

        tn.tabs[_index].isActive = false;
      }

      if (tn.tabs[_index].isActive) {
        counter++;
      }
    });

    $timeout(function () {

      tn.isExpanded = !!counter;

      navigationAnalytics.taxonomyNavigation(tn.tabs[index].title + '-tab');
    });
  };

  tn.hideTab = function (index) {

    tn.tabs[index].isActive = false;
    tn.isExpanded = false;
    tn.activeTab = '';
  };

  tn.getTabTitle = function (tab) {
    let title

    switch ($rootScope.lang) {
      case 'en-us':
        title = tab.title
        break;

      case 'zh-cn':
        title = tab.titleCN
        break;

      case 'zh-hk':
        title = tab.titleHK
        break;

      default:
        break;
    }

    return title
  }

  /**
   *
   * @PRIVATE_METHODS
   *
   */

  function Tab(data) {
    var titleEN = data.titleEN;
    var titleCN = data.titleCN;
    var titleHK = data.titleHK;
    var activeStates = data.activeStates;
    var target = data.target;
    this.title = titleEN;
    this.titleCN = titleCN;
    this.titleHK = titleHK;
    this.slug = titleEN.toLowerCase();
    this.order = tn.tabs.length;
    this.activeStates = activeStates;
    this.isActive = false;
    this.target = target;
    this.data = [];
    if (titleEN.toLowerCase() === 'channels') {
      this.modules = {
        items: [{
          type: 'nnCategoriesList'
        }]
      };
    }
  }

  function _createTabs() {

    var series = new Tab({
      titleEN: $translate.instant('SERIES', {}, undefined, 'en-us'),
      titleCN: $translate.instant('SERIES', {}, undefined, 'zh-cn'),
      titleHK: $translate.instant('SERIES_TAX', {}, undefined, 'zh-hk'),
      activeStates: ['main.series'],
      tag:'首页-导航-系列短片按钮',
      target: '/series'
    });
    var channels = $rootScope.lang === 'zh-cn' ? new Tab({
      titleEN: $translate.instant('CHANNELS', {}, undefined, 'en-us'),
      titleCN: $translate.instant('CHANNELS', {}, undefined, 'zh-cn'),
      titleHK: $translate.instant('CHANNELS', {}, undefined, 'zh-hk'),
      activeStates: ['main.category'],
      tag:'首页-导航-栏目频道按钮',
      target: ''
    }) : null;
    var topics = ($rootScope.lang === 'en-us' || $rootScope.lang === 'zh-hk') ? new Tab({
      titleEN: $translate.instant('TOPICS', {}, undefined, 'en-us'),
      titleCN: $translate.instant('TOPICS', {}, undefined, 'zh-cn'),
      titleHK: $translate.instant('TOPICS_TAX', {}, undefined, 'zh-hk'),
      activeStates: ['main.tagLanding'],
      target: '/topics'
    }) : null;
    var picks = new Tab({
      titleEN: $translate.instant('PICKS', {}, undefined, 'en-us'),
      titleCN: $translate.instant('PICKS', {}, undefined, 'zh-cn'),
      titleHK: $translate.instant('PICKS_TAX', {}, undefined, 'zh-hk'),
      activeStates: ['main.picksLanding'],
      tag:'首页-导航-特别精选按钮',
      target: '/picks'
    });
    var tabs = [series, channels, topics, picks];

    tabs.forEach(function (item) {
      if (item) {
        tn.tabs.push(item);
      }
    });
  }

  function _hideAllTabs() {

    tn.tabs.forEach(function (item) {

      item.isActive = false;
    });

    tn.isExpanded = false;
    tn.activeTab = '';
  }

  function _getTabByTitle(title) {

    return tn.tabs.filter(function (tab) {

      return (tab.title.toLowerCase() === title.toLowerCase());
    })[0];
  }

  function _loadModules() {

    apiModulesService
      .getModules('menu-series,menu-categories,menu-topics,menu-picks')
      .then(function (res) {

        res.data.items.forEach(function (module) {

          var tabTitle = module.parentType.replace('menu-', '');
          var tab = _getTabByTitle(tabTitle);

          if (tab) {

            if (!tab.modules) {
              tab.modules = {
                items: []
              };
            }

            tab.modules.items.push(module);
          }
        });
      });
  }

  function _onClick(event) {
    var isChild = $($element).has(event.target).length > 0;
    var isSelf = $element[0] === event.target;
    var isInside = isChild || isSelf;

    if (!isInside) {

      _onClickOutside();
    }
  }

  function _onClickOutside() {

    $timeout(function () {

      _hideAllTabs();
    });
  }

  function _onDestroy(_fn) {

    $scope.$on('$destroy', function () {

      if (_fn) {
        _fn();
      }
    });
  }

  function _onStateChangeSuccess(fn) {

    $rootScope.$on('$stateChangeSuccess',
      function (event, toState, toParams, fromState, fromParams) {

        if (fn) {

          fn(event, toState, toParams, fromState, fromParams);
        }
      });
  }

  function _bindEvents() {

    $document.bind('click', _onClick);
  }

  function _unbindEvents() {

    $document.unbind('click', _onClick);
  }

  function _addSeasons() {
    if ($rootScope.lang !== 'en-us' && $rootScope.lang !== 'zh-hk') {
      tn.tabsLoading = false;
    }

    return apiSeasonsService
      // .getSeasons(1, 1, 'publishDate desc')
      .getSeasons()
      .then(function (response) {

        if (response.data && response.data.items[0]) {
          var season = transObject.translate(response.data.items[0]);
          $rootScope.latestSeasons = season;
          if ($rootScope.lang !== 'zh-cn') {
            var seasons = new Tab({
              titleEN: $rootScope.bWidth < 420 ? $translate.instant('PROGRAMS', {}, undefined, 'en-us') : $translate.instant('SPECIAL_PROGRAMS', {}, undefined, 'en-us'),
              titleCN: '',
              titleHK: $translate.instant('PROGRAMS_TAX', {}, undefined, 'zh-hk'),
              activeStates: ['main.seasons', 'main.seasonsSingle'],
              target: '/seasons'
            });

            tn.tabs.push(seasons);
          }
        }
        tn.tabsLoading = false;
      });
  }

  function _updateSeasonsLabel() {
    var mobileTitle = $translate.instant('PROGRAMS', {}, undefined, 'en-us');
    var desktopTitle = $translate.instant('SPECIAL_PROGRAMS', {}, undefined, 'en-us');

    if ($rootScope.bWidth < 420) {
      tn.tabs.forEach(function (item, index) {
        if (desktopTitle === item.title) {
          tn.tabs[index].title = mobileTitle;
          tn.tabs[index].tab.titleHK = $translate.instant('PROGRAMS_TAX', {}, undefined, 'zh-hk');
        }
      });
    } else {
      tn.tabs.forEach(function (item, index) {
        if (mobileTitle === item.title) {
          tn.tabs[index].title = desktopTitle;
          tn.tabs[index].tab.titleHK = $translate.instant('PROGRAMS_TAX', {}, undefined, 'zh-hk');
        }
      });
    }
  }

  /**
   *
   * @INIT
   *
   */

  _createTabs();
  _addSeasons();

  if ($rootScope.lang === 'zh-cn') {
    _bindEvents();
    _loadModules();
    _onDestroy(function () {

      _unbindEvents();
    });
    _onStateChangeSuccess(function () {

      $timeout(function () {

        _hideAllTabs();
      }, 100);
    });

  } else {

    $rootScope.$watch('bWidth', function () {
      _updateSeasonsLabel();
    });

  }

  const scrollHandle = _throttle(() => {
    $scope.$apply(_hideAllTabs())
    window.removeEventListener('scroll', scrollHandle)
  }, 500)

  $scope.$watch('tn.activeTab', val => {
    if (val) {
      window.addEventListener('scroll', scrollHandle)
    }
  })

  $scope.$on('$destroy', () => {
    window.removeEventListener('scroll', scrollHandle)
  });


}

export default NnTaxonomiesNavigationDirective;



// WEBPACK FOOTER //
// ./app/components/nn-navigation/nn-taxonomies-navigation/nn-taxonomies-navigation.directive.js